<template lang='pug'>
.monitoring-console(style='height:100%;')
  .row
    .col-md-12.text-center
      .previous-and-next
        i.fpui.fpui-angle-double-left.fpui-2x.blue.pointer(
          @click="previous()",
          fpui-tooltip="$t('Previous') + ' logs'"
        )
        i.fpui.fpui-angle-double-right.fpui-2x.blue.pointer(
          @click="next()",
          v-tooltip="$t('Next') + ' logs'"
        )
      div.pull-right
        div(v-if="!fetching")
          fpui-button.refreshed(color="blue", icon="fa fa-refresh", @click="doRequest(true)", reverse)
        div(v-else)
          fpui-button.refreshed(color="blue", icon="fa fa-refresh fa-spin", disabled, reverse)
  hr
  .filter
    fpui-input-search(color="blue", v-model="filterBy", :placeholder="$t('Filter')")
  .logView
    pre.real-white-spaces
      span(v-if='showLine(line)', v-for="line, index in lines", v-html="getLine(line)", :key='index')

</template>

<script>
import {
  default as AnsiUp
} from 'ansi_up'
const ansi = new AnsiUp()

export default {
  props: {
    value: { type: Object, required: true },
    fpapi: { type: Object, required: true }
  },
  data () {
    return {
      lines: [],
      filterBy: '',
      fetching: false,
      tail: 100
    }
  },
  computed: {
    options () { return { tailLines: this.tail } }
  },
  created () {
    this.doRequest(true)
  },
  methods: {
    doRequest (withLoading = false) {
      if (typeof this.fpapi.logs === 'function') {
        if (withLoading) this.fetching = true
        this.fpapi.logs(this.value.name, this.options)
          .then(data => {
            if (typeof (data) !== 'string') {
              data = ''
            }
            let splitData = data.split('\n')
            splitData.splice(100, this.tail)
            this.lines.splice(0, this.lines.length)
            splitData.forEach(line => this.lines.push(line))
            if (!this.lines.length) this.lines = ['No logs']
            this.fetching = false
          })
          .catch(err => {
            this.$fpuiMessageBlock.error(err)
            this.fetching = false
          })
      }
    },
    next () {
      if (this.tail > 100) {
        this.tail -= 100
        this.doRequest()
      }
    },
    previous () {
      this.tail += 100
      this.doRequest()
    },
    getLine (line) { return ansi.ansi_to_html(line) + '\n' },
    showLine (line) {
      if (this.filterBy.length === 0) return true
      return line.indexOf(this.filterBy) !== -1
    }
  }
}
</script>

<style lang='less'>
  @import '~@/shared/styles/_variables.less';

  .monitoring-console {
    position:relative;
    .previous-and-next {
      position:absolute;
      left: 20px;
      i {
        color: @blue;
      }
    }
    .real-white-spaces {
      white-space: pre-wrap;
    }
    .logView {
      color: #fefefe;
      background-color: #333333;
      overflow: auto;
      height: 400px;
      pre {
        font-size: 13px;
        font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
        margin: 0;
        border-radius: 4px;
        border: none;
        background: transparent;
        color: inherit;
        padding: 20px;
      }
    }
  }
</style>
